import { Col, Divider, Row } from "antd";
import styled from "styled-components";

interface ProductCardContainerProps {
  backgroundcolor?: string;
  height?: string;
}

interface ProductImageProps {
  widthandheight?: string;
}

interface StyledDividerProps {
  margintop?: string;
  marginbottom?: string;
}

export const ProductCartContainer = styled(Col)<ProductCardContainerProps>`
  background-color: ${(props) => (props.backgroundcolor ? props.theme.colors[props.backgroundcolor!] : "")};
  height: ${(props) => (props.height ? props.height : "200px")};
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border-radius: 20px !important;
  width: 150px;

  &:hover {
    cursor: pointer;
  }
`;

export const ProductCartContainerRow = styled(Row)<ProductCardContainerProps>`
  padding: 10px 5px 10px 5px;
  height: ${(props) => (props.height ? props.height : "250px")};
  overflow-y: scroll;
`;

export const ProductImageContainer = styled.div<ProductImageProps>`
  img {
    width: ${(props) => (props.widthandheight ? props.widthandheight : "80px")};
    height: ${(props) => (props.widthandheight ? props.widthandheight : "80px")};
    object-fit: scale-down;
  }
`;

export const SelectedProductContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  height: 200px;
`;

export const OrderSummaryCartContainer = styled.div`
  width: 90%;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  height: 80%;
  border-radius: 20px;
  padding: 20px;
`;

export const StyledHomeDeliveryDivider = styled(Divider)<StyledDividerProps>`
  margin-top: ${(props) => (props.margintop ? props.margintop : "5px")} !important;
  margin-bottom: ${(props) => (props.marginbottom ? props.marginbottom : "5px")} !important;
`;

export const OrderSummaryCard = styled.div`
  display: flex;
  width: 100%;
  height: 100px;
`;

export const OrderSummaryQuantity = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  border-radius: 5px;
  padding: 8px 8px 8px 8px;
  background-color: ${(props) => props.theme.colors.primary};
  width: 30px;
`;
